import { render } from "./BenchmarkCompanyList.vue?vue&type=template&id=879cbf22"
import script from "./BenchmarkCompanyList.vue?vue&type=script&lang=js"
export * from "./BenchmarkCompanyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__